<div *ngIf="isValidIndicator" class="validation-message icon-system_error" [ngbPopover]="tooltip" triggers="click hover" container="body" popoverClass="validation-error"></div>
<span [ngClass]="{'push-right':isValidIndicator}">{{params.valueFormatted}}</span>

<ng-template #tooltip>
  <div class="message-text">
    <p>{{validationMessage | translate}}</p>
  </div>
</ng-template>
